export const dishes = [
    '3472', '3093', '3033', '2299', '3477', '3416', '122', '3417',
    '3415',
    '3843', '3857',
    '3873', '3874', '1135', '1257', '3835', '3834',
];
